// 🔧 /src/layouts/app_layout.js
// ✅ Purpose: Event-scoped route layout wrapper for LGV
// ✅ Features:
// - Uses the original ResponsiveNav navigation system
// - Preserves React Router nested routing through <Outlet />
// - Keeps volunteer shift banner above routed page content
// - Keeps footer below routed page content
// - Does not use AppShell, TopNav, or Sidebar

import React, { useEffect } from "react";
import { Outlet, Link, useLocation } from "react-router-dom";
import { useAuthState } from "react-firebase-hooks/auth";
import { auth } from "../firebase";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "../assets/css/slick.css";
import "../assets/css/style.css";
import { useEventContext } from "../hooks/use_event_context";
import { useUpcomingVolunteerShift } from "../hooks/useUpcomingVolunteerShift";
import ResponsiveNav from "../components/ResponsiveNav";
import Footer from "../components/footer";
import { logger } from "../utils/logger";
import { setAnalyticsEventContext, trackEventVisit } from "../utils/analytics";

const AppLayout = () => {
  const [user] = useAuthState(auth);
  const { pathname } = useLocation();

  const {
    eventId,
    eventslug,
    eventDoc,
  } = useEventContext();

  const hasUpcomingShift = useUpcomingVolunteerShift();

  logger.log("👤 user:", { value: user });
  logger.log("🧵 eventslug:", { value: eventslug });
  logger.log("🆔 eventId:", { value: eventId });
  logger.log("📍 pathname:", { value: pathname });

  useEffect(() => {
    setAnalyticsEventContext({ eventId, eventSlug: eventslug });
    if (eventId && eventslug) trackEventVisit({ eventId, eventSlug: eventslug, sourcePage: pathname });
  }, [eventId, eventslug, pathname]);

  useEffect(() => {
    if (!eventslug) {
      return;
    }

    const recentEvent = {
      slug: eventslug,
      name: eventDoc?.name || "this event",
      savedAt: Date.now(),
    };

    localStorage.setItem("LGV_RECENT_EVENT", JSON.stringify(recentEvent));

    console.log("[LGV Recent Event] Saved:", recentEvent);
  }, [eventslug, eventDoc?.name]);

  return (
    <div className="lgv-page-shell">

      <ResponsiveNav />

      {hasUpcomingShift && eventslug && (
        <div className="alert alert-warning text-center mb-0">
          ⏰ You have a volunteer shift coming up.{" "}
          <Link to={`/${eventslug}/volunteering`} className="alert-link">
            View your schedule
          </Link>
        </div>
      )}

      <main className="lgv-route-content">
        <Outlet />
      </main>

      <Footer />

    </div>
  );
};

export default AppLayout;
